import { aiAnalyzerApi } from '@/lib/api';
import { poll } from '@/lib/polling';

import type {
  AnalyzeEvaluationRequest,
  AnalysisResponse,
  AnalysisResult,
} from './aiAnalysis.types';

export const analyzeCheckpoint = (data: AnalyzeEvaluationRequest) => {
  return aiAnalyzerApi.post<AnalysisResponse>(
    '/api/v1/analyze-evaluation',
    data,
  );
};

export const getAnalysisResult = (analysisId: string) => {
  return aiAnalyzerApi.get<AnalysisResult>(`/api/v1/analysis/${analysisId}`);
};

export const pollAnalysisResult = async (
  analysisId: string,
  maxAttempts: number = 60,
  intervalMs: number = 2000,
): Promise<AnalysisResult> => {
  return poll(() => getAnalysisResult(analysisId), {
    maxAttempts,
    intervalMs,
    isInProgress: (result) =>
      ['pending', 'in_progress', 'processing', 'analyzing'].includes(
        result.status,
      ),
    onComplete: (result) => {
      if (result.status === 'failed') {
        console.error('[AI Analyzer] Analysis failed:', result.error);
      } else {
        console.log('[AI Analyzer] Analysis completed');
      }
    },
    onPoll: (result, attempt) => {
      console.log(
        `[AI Analyzer] Polling attempt ${attempt}, status: ${result.status}`,
      );
    },
  });
};
